// Profile Content Constants

export const LANGUAGES = [
    { code: 'en', label: '🇬🇧 English' },
    { code: 'hi', label: '🇮🇳 Hindi' },
    { code: 'ar', label: '🇸🇦 Arabic' },
    { code: 'cs', label: '🇨🇿 Czech' }
];

export const REPORT_TYPES = [
    { id: 'advanced', label: 'Total' },
    { id: 'dynamic', label: 'Personal' },
    { id: 'compact', label: 'Compact' },
    { id: 'vizapp', label: 'VizApp' },
    { id: 'others', label: 'Others' }
];

export const SECTIONS = {
    about: { label: 'About' },
    tips: { label: 'Tips' }
};

// Default language template for new content
export const DEFAULT_LANG_OBJ = {
    en: '',
    hi: '',
    ar: '',
    cs: ''
};

// Profile template for new profiles
export const PROFILE_TEMPLATE = {
    advanced: {
        about: {
            header: { en: '', ar: '', hi: '', cs: '' },
            text: { en: '', ar: '', hi: '', cs: '' }
        },
        tips: []
    },
    dynamic: {
        about: {
            header: { en: '', ar: '', hi: '', cs: '' },
            text: { en: '', ar: '', hi: '', cs: '' }
        },
        tips: []
    },
    compact: {
        about: {
            header: { en: '', ar: '', hi: '', cs: '' },
            text: { en: '', ar: '', hi: '', cs: '' }
        },
        tips: []
    }
};

